import styled from 'styled-components';

interface StyledCircleProps {
  severity: number;
}
export const StyledCircle = styled.span<StyledCircleProps>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme, severity }) =>
    severity === 5 ? theme.red : severity === 4 ? theme.orange : theme.green};
  display: inline-block;
`;

export const SeverityContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
